import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import PersonalKostenSkizzeLoewe, { getFormStrucPersonalKostenSkizzeEmob } from './PersonalKostenSkizzeLoewe';

// import Schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getVerbundPartnerName } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
const P = Schema.attributes;

export const GetPersonalKostenSkizzeLoewe = (application: any, hasCommentAusgabenUndFinanzierung?: boolean) => {
	const OrgaStruc = [
		{
			label: get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, `Antragsteller`),
			content: (
				<PersonalKostenSkizzeLoewe
					kostentraeger='Antragsteller'
					unternehmenId={get(getLocalstorageToken(), 'organisationId')}
					hasComment={hasCommentAusgabenUndFinanzierung}
				/>
			),
			formStruc: getFormStrucPersonalKostenSkizzeEmob(application, get(getLocalstorageToken(), 'organisationId')),
		},
	];
	const STRUC = get(application, P.Verbundpartner.path, []).map((_ele: any, i: number) => {
		return {
			label: `${getVerbundPartnerName(_ele, i)}`,
			content: (
				<PersonalKostenSkizzeLoewe
					kostentraeger='Verbundpartner'
					unternehmenId={get(_ele, 'Verbundpartner.id')}
					hasComment={hasCommentAusgabenUndFinanzierung}
				/>
			),
			formStruc: getFormStrucPersonalKostenSkizzeEmob(application, get(_ele, 'Verbundpartner.id')),
		};
	});
	return [...OrgaStruc, ...STRUC];
};
